module.exports = __webpack_public_path__ + "img/baguette.be86e805.svg";